import { render, staticRenderFns } from "./EventAndTipsSection.vue?vue&type=template&id=05f580da&scoped=true&"
import script from "./EventAndTipsSection.vue?vue&type=script&lang=js&"
export * from "./EventAndTipsSection.vue?vue&type=script&lang=js&"
import style0 from "./EventAndTipsSection.vue?vue&type=style&index=0&id=05f580da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f580da",
  null
  
)

export default component.exports